/* import __COLOCATED_TEMPLATE__ from './address.hbs'; */
var _class, _descriptor;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import Component from '@glimmer/component';
import getPostalCodeFormatter from '@banking/ui/utils/field-kit-formatters/postal-code';
import assert, { assertInstanceOf, assertNonNullable } from '@banking/ui/utils/assert';
import { TextField } from 'field-kit';
import { FieldIdentifier } from '@banking/ui/models/common/address';
import * as countryAddressDataUtil from '@banking/ui/utils/country-address-data';
import { inject as service } from '@ember/service';
import { Country } from '@square/dashboard-protos/models/squareup/common/countries';
var AdministrativeAreaField = /*#__PURE__*/function (AdministrativeAreaField) {
  AdministrativeAreaField[AdministrativeAreaField["NONE"] = 0] = "NONE";
  AdministrativeAreaField[AdministrativeAreaField["INPUT_TEXT"] = 1] = "INPUT_TEXT";
  AdministrativeAreaField[AdministrativeAreaField["SELECT"] = 2] = "SELECT";
  return AdministrativeAreaField;
}(AdministrativeAreaField || {});
let Address = (_class = class Address extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    // "static" properties
    _defineProperty(this, "FieldIdentifier", FieldIdentifier);
    _defineProperty(this, "AdministrativeAreaField", AdministrativeAreaField);
  }
  get addressCountry() {
    const countryCode = assertNonNullable(this.args.countryAddressData.countryCode);
    const country = assertNonNullable(Country[countryCode]);
    return country;
  }
  get postalCodeFormatter() {
    return getPostalCodeFormatter(this.addressCountry);
  }

  // formats postal code when there is an init value and when the postalCode property changes.
  get formattedPostalCode() {
    return this.args.postalCode != null ? this.postalCodeFormatter.format(this.args.postalCode) : '';
  }
  get postalCodeLabel() {
    return this.intl.t(countryAddressDataUtil.postalCodeLabelTranslationKey(this.args.countryAddressData.postalCodeLabel));
  }
  get administrativeAreaLabel() {
    return this.intl.t(countryAddressDataUtil.admin1LabelTranslationKey(this.args.countryAddressData.admin1Label, this.addressCountry));
  }
  get localityLabel() {
    return this.intl.t(countryAddressDataUtil.localityLabelTranslationKey(this.args.countryAddressData.localityLabel));
  }
  /** *
   * For UK addresses, administrative area is an optional text field labeled "County"
   * For US/CA addresses, it's a dropdown of states, with predefined values from countryAddressData.admin1Values
   */
  get administrativeAreaField() {
    if (this.addressCountry === Country.GB) {
      return AdministrativeAreaField.INPUT_TEXT;
    } else if (this.args.countryAddressData.admin1Values?.length > 0) {
      return AdministrativeAreaField.SELECT;
    } else {
      return AdministrativeAreaField.NONE;
    }
  }
  async initializeFieldKit(fieldCandidate, marketInputTextElement) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && fieldCandidate in FieldIdentifier);
    // FIXME(steckel): Find a way to type-narrow over type-casting
    const fieldIdentifier = fieldCandidate;
    const inputElement = await marketInputTextElement.getInputElement();
    const fieldKit = new TextField(inputElement, this.postalCodeFormatter);
    const textDidChange = field => this.args.onValueChange(fieldIdentifier, field.value());
    fieldKit.setDelegate({
      textDidChange
    });
  }
  onInputChange(fieldCandidate, event) {
    assert(fieldCandidate != null && typeof fieldCandidate === 'string' && fieldCandidate in FieldIdentifier);
    // FIXME(steckel): Find a way to type-narrow over type-casting
    const fieldIdentifier = fieldCandidate;
    const val = assertInstanceOf(event, CustomEvent).detail.value;
    this.args.onValueChange(fieldIdentifier, val);
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "initializeFieldKit", [action], Object.getOwnPropertyDescriptor(_class.prototype, "initializeFieldKit"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onInputChange", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onInputChange"), _class.prototype)), _class);
export { Address as default };